import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { constant } from './Constants';
import cloneDeep from 'lodash.clonedeep';
import { bindActionCreators } from 'redux';
import menuAdapter from '../Adapter/MenuAdapter';
import { GlobalHeader, GlobalHeaderLogo } from './styles';
import localStorage from '../../../../../utils/localStorage';
import { Menu, Dropdown, Space, ConfigProvider, Skeleton } from 'antd';
import LayoutAction from '../../../../../modules/actions/LayoutAction';
import { API_LANGUAGE, LANDINGPAGE, UPLOAD } from '../../../../../commons/api';
import TranslationAction from '../../../../../modules/actions/TranslationAction';
import {
  CaretDownOutlined,
  FullscreenOutlined,
  GlobalOutlined,
  LogoutOutlined,
  UserOutlined
} from '@ant-design/icons';
import { persistor, store } from '../../../../../modules/store';

class SlideMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMenu: '',
      userProfile: props.userProfile || {},
      loggedInRole: {},
      logoPath: '',
      rightMenuAlignment: 'right',
      selectedMenu: [] || '',
      firstLevelMenu: [],
      secondLevelMenu: [],
      menuHierarchy: props.menuHierarchy || {},
      notificationList: [],
      currentSite: localStorage.get('currentSite') || '',
      navigationMode: 'top',
      translationCache: props.translationCache || [],
      languageList: []
    };
  }

  componentDidMount() {
    const width = window.innerWidth;
    if (width > 1466) {
      this.setState({ rightMenuAlignment: 'right' });
    } else {
      this.setState({ rightMenuAlignment: 'none' });
    }
    this.getLanguageList();
  }

  componentDidUpdate(prevProps) {
    let { menuHierarchy } = this.state;
    let { selectedMenu } = this.props;
    if (prevProps.translationCache !== this.props.translationCache) {
      let firstLevelMenu = menuAdapter.firstMenuAdapter(menuHierarchy, this.props.translationCache);


      this.getSecondLevelMenu(menuHierarchy, selectedMenu[0]);
      this.setState({
        menuHierarchy,
        firstLevelMenu,
        translationCache: this.props.translationCache
      });

    }

    //menuHierarchy change
    if (this.props.menuHierarchy !== prevProps.menuHierarchy) {
      menuHierarchy = this.props.menuHierarchy;
      let firstLevelMenu = menuAdapter.firstMenuAdapter(menuHierarchy, this.props.translationCache);

      this.getSecondLevelMenu(menuHierarchy, selectedMenu && selectedMenu[0] ? selectedMenu[0] : "");

      this.setState({
        menuHierarchy,
        firstLevelMenu
      });
    }
    if (this.props.selectedMenu !== prevProps.selectedMenu) {
      if (selectedMenu.length >= 2) {
        this.setState({ currentMenu: selectedMenu[1] });
      }
      this.getSecondLevelMenu(menuHierarchy, selectedMenu[0]);
    }
    if (this.props.userProfile !== prevProps.userProfile) {
      this.getRole(this.props.userProfile);
    }
  }

  getLanguageList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let changePassword = {
      method: 'GET',
      url: `${API_LANGUAGE.LanguageList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(changePassword)
      .then((response) => {
        this.setState({
          languageList: response.data
        });
        this.props.translationAction.translationAuth(response.data && response.data[0].Name);
      })
      .catch(function () { });
  };

  getSecondLevelMenu = async (menuHierarchy, selectedMenu) => {
    let menuHierarchyClone = cloneDeep(menuHierarchy);
    let secondLevelMenu = await menuAdapter.secoundMenuAdapter(
      menuHierarchyClone,
      selectedMenu || 'Modules',
      this.props.translationCache
    );
    this.setState({ secondLevelMenu });
  };

  UNSAFE_componentWillReceiveProps({ currentLanguage, currentSite, userProfile, selectedMenu }) {
    if (userProfile && userProfile.belongsTo) {
      this.setState({
        currentLanguage,
        currentSite,
        userProfile,
        selectedMenu
      });
    } else {
      this.setState({ currentLanguage, userProfile, selectedMenu });
    }
  }

  getRole = async (userProfile) => {
    let currentSiteId = localStorage.get('currentSite');
    let logoPath =
      currentSiteId &&
        userProfile &&
        userProfile.belongsTo &&
        userProfile.belongsTo.sites &&
        userProfile.belongsTo.sites[currentSiteId] &&
        userProfile.belongsTo.sites[currentSiteId].site &&
        userProfile.belongsTo.sites[currentSiteId].site['ImageURL']
        ? userProfile.belongsTo.sites[currentSiteId].site['ImageURL']
        : '';

    this.setState({
      logoPath
    });
  };

  translation = (keyword) => {
    let { translationCache } = this.props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  getSubMenuOrItem = (item, menuLevel) => {
    let { selectedMenu, menuHierarchy } = this.state;
    return (
      <Menu.Item
        key={item.key}
        onClick={() => {
          if (menuLevel === 'firstLevelMenu') {
            let defaultPageValueSetting = menuAdapter.setFirstDefaultPages(
              this.state.menuHierarchy,
              [],
              item
            );
            if (item && item.key === 'ApplicationSettings') {
              this.props.navigate('/rubus/settingsPage/Profile');
            } else if (defaultPageValueSetting.length === 1) {
              this.props.layoutAction.setMenuSelection(defaultPageValueSetting);
              if (
                menuHierarchy &&
                menuHierarchy[defaultPageValueSetting[0]] &&
                menuHierarchy[defaultPageValueSetting[0]].path
              ) {
                this.props.navigate(menuHierarchy[defaultPageValueSetting[0]].path);
              }
            } else if (defaultPageValueSetting.length >= 2) {
              this.props.layoutAction.setMenuSelection(defaultPageValueSetting);
              this.props.navigate(
                menuHierarchy[defaultPageValueSetting[0]].children[defaultPageValueSetting[1]].path
              );
            }
          } else if (menuLevel === 'secondLevelMenu') {
            selectedMenu =
              selectedMenu && Array.isArray(selectedMenu)
                ? selectedMenu
                : ['Modules', 'rt_dashboard'];
            const defaultSecondLevel = menuAdapter.setSecondDefaultPages(
              this.state.menuHierarchy,
              selectedMenu,
              item
            );
            let finalResult = [...defaultSecondLevel];
            this.props.layoutAction.setMenuSelection(finalResult);
            this.props.navigate(item.path);
          }
        }}
      >
        {/* <Icon type="message" style={{  color: '#08c' }} theme="outlined" /> */}
        <span className="nav-text">{this.translation(item.name)}</span>
      </Menu.Item>
    );
  };

  getNavMenuItems = (menusData, menuLevel) => {
    if (!menusData) {
      return [];
    }
    if (Array.isArray(menusData)) {
      return menusData
        .filter((item) => item && item.name && !item.hideInMenu)
        .map((item) => {
          return this.getSubMenuOrItem(item, menuLevel);
        })
        .filter((item) => item);
    }
  };

  setLanguage = (language) => {
    this.props.translationAction.translationAuth(language);
    localStorage.set('currentLanguage', language);
  };

  getLandingPageById = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${LANDINGPAGE.GET}?Id=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (data && Array.isArray(data) && data[0]) {
          let LOGO = ['Modules'];
          this.props.layoutAction.setMenuSelection(LOGO);
          this.props.navigate(data[0].Path);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  onsMenuClick = (item) => {
    let { selectedMenu } = this.state;
    let menu = [selectedMenu[0] || "Modules", item.key];
    let defaultSecondLevel = menuAdapter.setSecondDefaultPages(
      this.state.menuHierarchy, menu, item
    );
    this.props.layoutAction.setMenuSelection(defaultSecondLevel);
    this.props.navigate(item.item.props.path);
  };

  languageMenu = async () => {
    let { languageList } = this.state;
    return languageList.map((language) => ({
      key: language,
      label: language
    }));
  };

  fetchLanguages = () => {
    return this.state.languageList;
  };

  render() {
    const { currentMenu, logoPath, firstLevelMenu, secondLevelMenu, languageList } = this.state;
    const { nativProps: { menuHierarchy }, userProfile, themeValue } = this.props;
    let siteId = localStorage.get('currentSite');
    const menuItemsLogOut = [
      ...(firstLevelMenu !== undefined && menuHierarchy ?
        firstLevelMenu.filter(item => item.key !== "Configuration")
          .map((fLMenu) => {
            return {
              key: fLMenu.key,
              label: this.translation(fLMenu.name),
            };
          })
        :
        []),
      {
        key: 'logOut',
        label: this.translation(constant.LogOut),
        icon: <LogoutOutlined />
      }

    ];
    const menu = {
      items: menuItemsLogOut,
      onClick: (e) => {
        if (e && e.key === "logOut") {
          localStorage.clear();
          persistor.purge();
          store.dispatch({ type: '@AUTH/USERLOGOUT/SUCCESS' });
          this.props.navigate('/login');
          window.location.reload();
        } else {
          let defaultPageValueSetting = menuAdapter.setFirstDefaultPages(
            this.state.menuHierarchy,
            [],
            { key: e.key }
          );

          if (e && e.key === 'ApplicationSettings') {
            this.props.navigate('/rubus/settingsPage/Profile');
          } else if (defaultPageValueSetting.length === 1) {
            this.props.layoutAction.setMenuSelection(defaultPageValueSetting);
            if (
              this.state.menuHierarchy &&
              this.state.menuHierarchy[defaultPageValueSetting[0]] &&
              this.state.menuHierarchy[defaultPageValueSetting[0]].path
            ) {
              this.props.navigate(this.state.menuHierarchy[defaultPageValueSetting[0]].path);
            }
          } else if (this.state.menuHierarchy && this.state.menuHierarchy[defaultPageValueSetting[0]] && defaultPageValueSetting.length >= 2) {
            this.props.layoutAction.setMenuSelection(defaultPageValueSetting);
            this.props.navigate(
              this.state.menuHierarchy[defaultPageValueSetting[0]].children[defaultPageValueSetting[1]].path
            );
          } else if (e.key === "Configuration") {
            return null;
          }
        }
      },
    };

    const handleMenuClick = ({ key }) => {
      const selectedLanguage = languageList.find(lang => lang.Code === key);
      const languageName = selectedLanguage.Name;
      this.props.translationAction.translationAuth(languageName);
    };

    const items = languageList && Array.isArray(languageList) ? languageList.map((language) => ({
      key: language.Code,
      label: language.Name
    })) : [];

    const pathName = JSON.stringify(this.props.location.pathname);
    const showmenu = !(
      pathName.match('editpanel') !== null ||
      pathName.match('/rubus/settingsPage') !== null
    );
    
    return (
      <ConfigProvider theme={{
        token: themeValue.token,
        components: themeValue.components,
        algorithm: themeValue.darkAlgorithm,
      }}>
        <GlobalHeader
          background={themeValue && themeValue.token && themeValue.token.colorBgBase}
          text={themeValue && themeValue.token && themeValue.token.colorTextBase}
        >
          <GlobalHeaderLogo>
            {
              logoPath !== '' ?
                <img
                  src={logoPath !== '' ? `${UPLOAD.Uploads}/${logoPath}` : ''}
                  alt="LOGO"
                  style={{
                    height: '60px',
                    maxWidth: '100%',
                    padding: '10px',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    let siteId = localStorage.get('currentSite');
                    let landingpageId =
                      userProfile &&
                        userProfile.belongsTo &&
                        userProfile.belongsTo.sites &&
                        userProfile.belongsTo.sites[siteId] &&
                        userProfile.belongsTo.sites[siteId].role &&
                        userProfile.belongsTo.sites[siteId].role.LandingPageId
                        ? userProfile.belongsTo.sites[siteId].role.LandingPageId
                        : '';
                    this.getLandingPageById(landingpageId);
                  }}
                />
                : <Skeleton.Input active={true} />
            }
          </GlobalHeaderLogo>
          <div style={{ flex: '1 1 0%' }}>
            {
              showmenu ?
                <Menu
                  onClick={this.onsMenuClick}
                  selectedKeys={[currentMenu]}
                  mode="horizontal"
                  items={
                    secondLevelMenu && secondLevelMenu.map((sMenu) => {
                      return {
                        label: sMenu.name,
                        key: sMenu.key,
                        path: sMenu.path
                      };
                    })}
                />
                : null}
          </div>
          <div
            style={{
              display: 'flex',
              float: 'right',
              marginLeft: 'auto',
              overflow: 'hidden',
              color: 'white'
            }}
          >
            {userProfile &&
              userProfile.belongsTo &&
              userProfile.belongsTo.sites &&
              Object.keys(userProfile.belongsTo.sites).length > 1 ? (
              <Dropdown
                overlay={
                  {
                    items: Object.keys(userProfile.belongsTo.sites) && Object.keys(userProfile.belongsTo.sites).length > 0 ?
                      Object.keys(userProfile.belongsTo.sites).map((siteId) => {
                        let siteDetails = userProfile.belongsTo.sites[siteId];
                        if (siteDetails && siteDetails.site && siteDetails.site.Name) {
                          return {
                            key: siteDetails.site.Name,
                            label: siteDetails.site.Name
                          };

                        } else {
                          return {
                            key: '',
                            label: ''
                          };
                        }
                      })
                      : []
                  }}
              >
                <>
                  <Space>
                    <div>
                      {siteId &&
                        userProfile &&
                        userProfile.belongsTo &&
                        userProfile.belongsTo.sites &&
                        userProfile.belongsTo.sites[siteId] &&
                        userProfile.belongsTo.sites[siteId].site
                        ? userProfile.belongsTo.sites[siteId].site.Name
                        : ''}
                      {''}
                      <CaretDownOutlined />
                    </div>
                  </Space>
                </>
              </Dropdown>
            ) : null}

            <Dropdown menu={menu} trigger={['click']}>
              <div onClick={(e) => e.preventDefault()}>
                <span style={{ margin: '4px' }}>
                  <UserOutlined
                    style={{
                      color: themeValue.token.colorText,
                      lineHeight: '72px',
                      marginTop: '13px',
                    }}
                  />
                  <span style={{ margin: '4px', color: themeValue.token.colorText }}>
                    {this.translation(
                      userProfile && userProfile.user && userProfile.user.FirstName ? userProfile.user.FirstName : ''
                    )}
                  </span>
                </span>
              </div>
            </Dropdown>
            <Dropdown
              menu={{ items, onClick: handleMenuClick }} trigger={['click']}>
              <div>
                <GlobalOutlined
                  style={{
                    color: themeValue.token.colorText,
                    lineHeight: '72px',
                    margin: '13px 10px 1px 18px'
                  }}
                />
              </div>
            </Dropdown>

            <FullscreenOutlined
              title={'fullscreen'}
              onClick={() => {
                document.fullscreenEnabled =
                  document.fullscreenEnabled ||
                  document.mozFullScreenEnabled ||
                  document.documentElement.webkitRequestFullScreen;

                if (document.fullscreenEnabled) {
                  this.props.fullScreen(document.documentElement);
                } else {
                  alert('full screen not supported');
                }
              }}
              style={{
                color: themeValue.token.colorText,
                lineHeight: '72px',
                margin: '10px'
              }}
            />
          </div>
        </GlobalHeader >
      </ConfigProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    currentSite: state.LayoutReducer.currentSite,
    selectedMenu: state.LayoutReducer.menuSelected,
    currentMenu: state.LoginReducer.userCurrentMenu,
    menuHierarchy: state.LayoutReducer.menuHierarchy,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutAction: bindActionCreators(LayoutAction, dispatch),
    translationAction: bindActionCreators(TranslationAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlideMenuComponent);
